import axios from 'axios'
import { baseUrl } from './config'

export function startFrutto () {
  return axios.post(`${baseUrl}/fruits-game/start`)
}

export function stopFrutto () {
  return axios.post(`${baseUrl}/fruits-game/stop`)
}

export function getGeneralStatistics () {
  return axios.get(`${baseUrl}/fruits-game/statistics`)
}

export function getStatisticsRoundsFrutto (params) {
  return axios.get(`${baseUrl}/fruits-game/games`, {
    params
  })
}
